import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import AddPrice from '../../components/AddPrice';

import WizardLayout from '../../components/WizardLayout';
import useWizardSteps from '../../hooks/useWizardSteps';
import WizardNavigation from '../../components/WizardNavigation';

import { Grid } from '@material-ui/core';

import { getInsuranceLocalInfo } from '../../utils';

import './style.scss';

const suggestion = (
  <span>
    <b>Completa los datos de tu auto</b> y conocé los planes que tenemos para
    vos
  </span>
);

export default function Price() {
  const [nextWasRequired, setNextWasRequired] = useState(false);
  const history = useHistory();
  const [activeStep] = useWizardSteps(1);

  const { isValidCar, insuranceName } = useSelector(
    ({ carInsurance, insurances }) => ({
      insuranceName: insurances.selected.insuranceName,
      isValidCar: carInsurance.userCarInsurance && carInsurance.isValid,
    })
  );

  const insuranceInfo = getInsuranceLocalInfo(insuranceName);

  const nextAction = () => {
    if (isValidCar) {
      history.push(`${insuranceInfo.url}/planes`);
    }
    setNextWasRequired(true);
    return;
  };

  return (
    // <div> HOLA </div>
    <WizardLayout activeStep={activeStep} suggestion={suggestion}>
      <Grid item xs={11} sm={12} container justify='center'>
        <AddPrice nextWasRequired={nextWasRequired} />
        <WizardNavigation nextAction={nextAction} />
      </Grid>
    </WizardLayout>
  );
}
